import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Timestamp } from 'firebase/firestore';

interface Category {
  id: string;
  name: string;
  userId: string;
  userEmail?: string;
  sopIds: string[];
  createdAt: Date | Timestamp;
  isPublic?: boolean;
  originalOwner?: {
    userId: string;
    name: string;
    profilePic?: string;
  };
}

interface UserFavorites {
  categories: Category[];
  sops: { [key: string]: any };
}

/**
 * Migrates categories from userFavorites collection to sopCategories collection
 * This is a one-time migration to move to a single collection model
 */
export const migrateCategoriesToSingleCollection = async (): Promise<{
  success: boolean;
  migratedCategories?: number;
  totalCategories?: number;
  error?: any;
}> => {
  try {
    
    
    // Get all user favorites documents
    const userFavoritesSnapshot = await getDocs(collection(db, 'userFavorites'));
    
    // Track migration progress
    let totalCategories = 0;
    let migratedCategories = 0;
    
    // Process each user's favorites
    for (const userDoc of userFavoritesSnapshot.docs) {
      const userData = userDoc.data() as UserFavorites;
      const userEmail = userDoc.id;
      
      // Use email as userId for now
      // In a real implementation, you might want to look up the actual userId
      const userId = userEmail;
      
      // Process each category
      if (userData.categories && Array.isArray(userData.categories)) {
        totalCategories += userData.categories.length;
        
        for (const category of userData.categories) {
          // Create a new document in sopCategories
          await setDoc(doc(db, 'sopCategories', category.id), {
            ...category,
            userId: userId, // Ensure userId is set
            userEmail: userEmail, // Store the email for reference
            createdAt: category.createdAt || new Date()
          });
          
          migratedCategories++;
        }
      }
    }
    
    
    return { success: true, migratedCategories, totalCategories };
  } catch (error) {
    
    return { success: false, error };
  }
};

/**
 * Helper function to fetch SOPs by their IDs
 * This would need to be implemented based on how you store SOPs
 */
export const fetchSOPsByIds = async (sopIds: string[]): Promise<{ [key: string]: any }> => {
  // This is a placeholder implementation
  // You would need to replace this with actual logic to fetch SOPs
  const sopsMap: { [key: string]: any } = {};
  
  // Example implementation:
  // const sopsSnapshot = await getDocs(
  //   query(collection(db, 'sops'), where('id', 'in', sopIds))
  // );
  // 
  // sopsSnapshot.forEach(doc => {
  //   const sop = doc.data();
  //   sopsMap[sop.id] = sop;
  // });
  
  return sopsMap;
};